/*
 * Botón «Preferencias de cookies» del pie (sections/bt-footer.liquid).
 * Reabre el banner de cookies de Shopify con privacyBanner.showPreferences().
 * Shopify solo carga ese banner si está activado en Configuración → Privacidad de los clientes;
 * si no está, el botón sigue oculto y no hace nada.
 */
(() => {
  const reveal = () => {
    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;

    document.querySelectorAll('[data-bt-cookie-prefs]').forEach((item) => {
      const button = item.querySelector('button');
      if (!button) return;
      item.hidden = false;
      button.addEventListener('click', () => {
        banner.showPreferences().catch(() => {});
      });
    });
  };

  // El script del banner llega desde content_for_header y puede terminar después que este.
  if (document.readyState === 'complete') {
    reveal();
  } else {
    window.addEventListener('load', reveal, { once: true });
  }
})();
